__turbopack_context__.v({
  "faq-accordion": "DzoOZa_faq-accordion",
  "faq-accordion-wrapper": "DzoOZa_faq-accordion-wrapper",
  "faq-accordion__body": "DzoOZa_faq-accordion__body",
  "faq-accordion__header": "DzoOZa_faq-accordion__header",
  "faq-accordion__heading": "DzoOZa_faq-accordion__heading",
});
